<template>
    <div class="grid-action d-flex align-items-center justify-content-center"><slot></slot></div>
</template>

<style lang="sass" scoped>
$grey-color: #efefef
$border-color: darken($grey-color, 7%)

.grid-action
    background-color: $grey-color
    border-right: 1px solid $border-color
    font-size: 1.2rem
</style>


<script>
export default { }
</script>
